module.exports = __webpack_public_path__ + "img/info-item-3.9e8bbade.png";